import { createSlice, current } from "@reduxjs/toolkit";
import _ from "lodash";

export interface ICommonState {
  loader: boolean;
  language: string;
  currencies: [];
  pageTabs: Array<any>;
}

export const initialState: ICommonState = {
  loader: false,
  language: "tr",
  currencies: [],
  pageTabs: [],
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    pageLoader: (state, action) => {
      state.loader = action.payload;
    },
    changeLanguage: (state, action) => {
      state.language = action.payload;
    },
    setPageTab: (state: any, action) => {
      const temp = current(state.pageTabs)?.length
        ? current(state.pageTabs)
        : [];
      const lastElement = temp && temp?.[temp.length - 1];
      const id = lastElement ? lastElement?.id + 1 : 0;

      const isInclude =
        temp?.length > 0 &&
        temp.find((tab: any) => tab.path === action.payload.path);

      if (!isInclude) {
        state.pageTabs = [...temp, { ...action.payload, id }];
      } else {
        const temp = current(state.pageTabs).filter(
          (tab: any) => tab.path !== action.payload.path
        );
        state.pageTabs = temp;
      }
    },
  },
});

const { actions, reducer } = commonSlice;
export const { pageLoader, changeLanguage, setPageTab } = actions;

export default reducer;
